export interface RcaInsuranceCompany {
    id: number;
    code: string;
    name: string;
}


export interface RcaForm {
    availability: Array<number> | number | null;
    valid_from: string | null;
    gdpr_agreement: boolean | null;
}

export const createDefaultRcaForm = (): RcaForm => {
    return {
        availability: [6, 12],
        valid_from: null,
        gdpr_agreement: false,
    }
}

export interface RcaAvailability {
    id: number;
    name: string;
}

export interface OfferForm {
    is_deducted: boolean | null;
    insurance_company: RcaInsuranceCompany | null;
}

export const createDefaultOfferForm = (): OfferForm => {
    return {
        is_deducted: false,
        insurance_company: null,
    }
}

export interface ApiOffer {
    response_body: {
        error: boolean;
        [key: string]: any;
    };
    [key: string]: any;
}

export interface ApiOfferSubArray {
    [key: number]: ApiOffer;
    [key: string]: any;
}


export interface RcaFormValidation {
    availability: boolean;
    valid_from: boolean;
    gdpr_agreement: boolean;
    [key: string]: boolean | boolean[]; // Add index signature
}

export interface RcaBaarValidation {
    reference_premium: number;
    threshold: number;
    is_high_risk: boolean;
    message: string;
}

export const createDefaultRcaFormValidation = (): RcaFormValidation => {
    return {
        availability: true,
        valid_from: true,
        gdpr_agreement: false,
    }
}
